import { render } from "./RestyleTooltip.vue?vue&type=template&id=585a9e05&scoped=true"
import script from "./RestyleTooltip.vue?vue&type=script&lang=js"
export * from "./RestyleTooltip.vue?vue&type=script&lang=js"

import "./RestyleTooltip.vue?vue&type=style&index=0&id=585a9e05&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585a9e05"]])

export default __exports__